import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ImageCounter = ({ numberOfImages, setNumberOfImages }) => {
  return (
    <div className="flex items-center border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-all duration-300 bg-white hover:border-[#4B3BFF] overflow-hidden h-10">
      <button
        onClick={() => setNumberOfImages(Math.max(1, parseInt(numberOfImages) - 1))}
        className="px-1 h-full text-gray-600 hover:text-[#4B3BFF] hover:bg-gray-50 transition-colors duration-300 flex items-center justify-center"
      >
        <FontAwesomeIcon icon={faMinus} className="text-xs" />
      </button>
      <input
        type="text"
        inputMode="numeric"
        pattern="[1-4]"
        value={numberOfImages}
        onChange={(e) => {
          const val = parseInt(e.target.value);
          if (!isNaN(val) && val >= 1 && val <= 4) {
            setNumberOfImages(val);
          }
        }}
        className="w-8 text-center h-full text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#4B3BFF] focus:border-transparent appearance-none"
        style={{ WebkitAppearance: "none", MozAppearance: "textfield" }}
      />
      <button
        onClick={() => setNumberOfImages(Math.min(4, parseInt(numberOfImages) + 1))}
        className="px-1 h-full text-gray-600 hover:text-purple-600 hover:bg-gray-50 transition-colors duration-300 flex items-center justify-center"
      >
        <FontAwesomeIcon icon={faPlus} className="text-xs" />
      </button>
    </div>
  );
};

export default ImageCounter; 